<div class="p-6">
  <!-- Header -->
  <div class="mb-6">
    <div class="flex items-center justify-between">
      <div>
        <h2 class="text-2xl font-bold text-gray-900 mb-2">Tarifas del Producto</h2>
        <p class="text-gray-600">Configura las tarifas y sus precios específicos para este producto</p>
      </div>
    </div>
  </div>

  <!-- GenericCRUD Component -->
  <app-generic-crud
    #priceListCrud
    [genericCrud]="priceListCrudConfig"
    (onFinished)="onCrudFinished()">
  </app-generic-crud>
</div>
